import React from 'react';
import { Gear as Cog, GasPump as Fuel, Gauge, Leaf, Lightning as Zap, ShieldCheck, Drop as Droplet } from '@phosphor-icons/react';
import FeatureCard from './FeatureCard';
import { noBreakUnits } from './utils/noBreakUnits';
import { t, translateValue } from './translations';

/**
 * Right column of the new-model print template — specs grid и Warranty +
 * Consommation cards. Title и price-bottom рендерятся на уровне темплейта
 * (NewModelPrintTemplate.jsx) — в горизонтали они уезжают в общий header
 * над divider'ом, в вертикали остаются в естественном column-flow.
 *
 * @param {object} props
 * @param {object} props.car — Car object (DealerCarDto).
 * @param {'fr'|'en'|'de'|'lu'} [props.language='fr']
 */
const NewModelInfoColumn = React.memo(function NewModelInfoColumn({ car, language = 'fr' }) {
  const FALLBACK_VALUE = t('fallback', language);
  const DEFAULT_WARRANTY = t('defaultWarranty', language);

  return (
    <div className="print-template__info-col">
      {/* Specs + cards. По дефолту (horizontal) — display:contents у grid,
          т.е. specs и cards рендерятся как прямые children info-col
          (specs 2-кол grid выше, cards в ряд ниже). В vertical grid
          превращается в flex-row: specs слева в 2 колонки, cards
          справа stacked сверху вниз (см. NewModelPrintTemplate.css). */}
      <div className="print-template__info-grid">
        <div className="print-template__specs">
          <div className="print-template__specs-col">
            <div className="print-template__spec">
              <Gauge className="print-template__spec-icon" weight="light" />
              <span className="print-template__spec-value print-template__spec-value--first">
                {noBreakUnits(translateValue(car.enginePower, language) || FALLBACK_VALUE)}
              </span>
            </div>
            {car.range && (
              <div className="print-template__spec">
                <Zap className="print-template__spec-icon" weight="light" />
                <span className="print-template__spec-value">{noBreakUnits(translateValue(car.range, language))}</span>
              </div>
            )}
          </div>
          <div className="print-template__specs-col">
            <div className="print-template__spec">
              <Cog className="print-template__spec-icon" weight="light" />
              <span className="print-template__spec-value">{translateValue(car.transmission, language) || FALLBACK_VALUE}</span>
            </div>
            <div className="print-template__spec">
              <Fuel className="print-template__spec-icon" weight="light" />
              <span className="print-template__spec-value">{translateValue(car.fuelType, language) || FALLBACK_VALUE}</span>
            </div>
          </div>
        </div>

        <div className="print-template__cards">
          <FeatureCard
            icon={ShieldCheck}
            label={t('warranty', language)}
            value={noBreakUnits(translateValue(car.warrantyTerm, language) || DEFAULT_WARRANTY)}
            compact
          />
          {car.consumption ? (
            <FeatureCard
              icon={Droplet}
              label={t('consumption', language)}
              value={noBreakUnits(translateValue(car.consumption, language))}
              compact
            />
          ) : car.co2Emissions ? (
            <FeatureCard
              icon={Leaf}
              label={t('co2', language)}
              value={noBreakUnits(translateValue(car.co2Emissions, language))}
              compact
            />
          ) : null}
        </div>
      </div>
    </div>
  );
});

export default NewModelInfoColumn;
